import { call, put } from 'redux-saga/effects'
import api from '../../../../services/api'
import * as Actions from './actions'

export function* searchRequest() {
    try {
        const client = yield call(api, 'protocolo');
        const response = yield call(client.get, `preparacao`);

        yield put(Actions.searchSuccess(response.data));
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}

export function* recoverPreparations({ filter }) {
    try {
        filter = !!filter ? filter : '';
        const client = yield call(api, 'protocolo');
        const response = yield call(client.get, `preparacao/${filter}`);

        yield put(Actions.searchSuccess(response.data));
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}

export function* createPreparation({ body }) {
    try {
        const client = yield call(api, 'protocolo');
        const response = yield call(client.post, `preparacao`, body);

        yield put(Actions.createSuccess(response.data));
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}

export function* deletePreparation({ id }) {
    try {
        const client = yield call(api, 'protocolo');
        yield call(client.delete, `preparacao/${id}`);

        yield put(Actions.deleteSuccess());
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}